import { Alert, type AlertProps, AlertTitle } from "@mui/material";
import classNames from "classnames";
import { forwardRef } from "react";
import styles from "./styles.module.css";
import { TNotification } from "../../../app/state/notificationSlice/types";

interface Props extends AlertProps {
  message: string;
  alertType: TNotification;
  title?: string;
  className?: string;
}

export const AppAlert = forwardRef<HTMLDivElement, Props>(
  ({ message, title, alertType, className, ...rest }, ref) => {
    return (
      <Alert
        ref={ref}
        className={classNames(
          styles["alert-message"],
          styles[`alert-${alertType}`],
          className
        )}
        {...rest}
      >
        {title && (
          <AlertTitle className={styles["alert-title"]}>{title}</AlertTitle>
        )}
        {message}
      </Alert>
    );
  }
);
